import React from "react";
import MainTemplate from "../../components/MainTemplate/MainTemplate";
import CardBackground from "../../components/MainTemplate/CardBackground";
import ManageRolesChild from "./ManageRolesChild";

const ManageRoles = () => {
  return (
    <MainTemplate>
      <CardBackground>
        <ManageRolesChild />
      </CardBackground>
    </MainTemplate>
  );
};

export default ManageRoles;
